/** @format */

import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "../app/hooks";
import { api } from "../app/services/api";
import BLSpinner from "../assets/animations/BLSpinner/BLSpinner";
import { getUserToken, setUserToken, UserToken } from "./authSlice";

const Logout: React.FC = () => {
  const dispatch = useDispatch();
  const token: UserToken | undefined = useAppSelector((state) =>
    getUserToken(state),
  );
  const userToken = localStorage.getItem("userToken");
  const [loggedOut, setLoggedOut] = useState<boolean>(false);

  useEffect(() => {
    if (!token && !userToken) setLoggedOut(true);
    dispatch(setUserToken(undefined));
    dispatch(api.util.invalidateTags(["User", "Resource"]));
    localStorage.removeItem("BL_CMS_STATE");
    setLoggedOut(true);
  }, [userToken, token, dispatch]);

  return loggedOut ? (
    <BLSpinner />
  ) : (
    <Navigate
      to={
        sessionStorage.getItem("redirectResource") === null
          ? "/"
          : `/${sessionStorage.getItem("redirectResource")}`
      }
    />
  );
};

export default Logout;
